import React from 'react'
import PropTypes from 'prop-types'

import BasePriceWithDiscount from './BasePriceWithDiscount'
import calculateOrderSummaryPrices from './calculateOrderSummaryPrices'

const priceLabelClassName = 'priceLabelMobileOrderDetails'
const priceClassName = 'priceMobileOrderDetails'
const discountBoxClassName = 'discountBoxMobileOrderDetails'
const discountLabelClassName = 'discountLabelMobileOrderDetails'
const mainBoxDirection = 'row'

const MobileOrderDetailsPrice = ({ fullPriceInfo, qty, enableUSBAddon, showEachSuffix }) => {
  const { finalPrice, discountLabel, price } = calculateOrderSummaryPrices({
    fullPriceInfo,
    qty,
    enableUSBAddon,
    showEachSuffix,
  })
  const discountMethod = fullPriceInfo.promo_discount_details?.discount_method

  return (
    <BasePriceWithDiscount
      finalPrice={finalPrice}
      price={price}
      discountLabel={discountLabel}
      priceLabelClassName={priceLabelClassName}
      priceClassName={priceClassName}
      discountMethod={discountMethod}
      discountBoxClassName={discountBoxClassName}
      discountLabelClassName={discountLabelClassName}
      mainBoxDirection={mainBoxDirection}
      isMobileOrderDetails
      alignItemsMainBox='center'
    />
  )
}

MobileOrderDetailsPrice.propTypes = {
  fullPriceInfo: PropTypes.object.isRequired,
  qty: PropTypes.number,
  enableUSBAddon: PropTypes.bool,
  showEachSuffix: PropTypes.bool,
}

export default MobileOrderDetailsPrice
